import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { SITE_NAME } from '../constants';
import { Reveal } from './Reveal';
import {
  ArrowRight,
  Layers,
  Paintbrush,
  GitBranch,
  BarChart3,
  Globe,
  Zap,
  Star,
  Shield,
  CheckCircle2,
  Sparkles,
  MousePointerClick,
  Play,
  ChevronRight,
  ArrowUpRight,
  Webhook,
  LayoutTemplate,
  type LucideIcon,
} from 'lucide-react';

/* ------------------------------------------------------------------ */
/*  INLINE SVG LOGOS                                                   */
/* ------------------------------------------------------------------ */

const LogoFull: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583.21 99.44" className={className}>
    <defs>
      <linearGradient id="lg1" x1="292.91" y1="-2.16" x2="305.94" y2="115.18" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
      <linearGradient id="lg2" x1="349.34" y1="-8.43" x2="362.38" y2="108.9" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
      <linearGradient id="lg3" x1="420.54" y1="-16.34" x2="433.58" y2="100.99" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
      <linearGradient id="lg4" x1="510.32" y1="-26.31" x2="523.35" y2="91.02" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
      <linearGradient id="lg5" x1="180.62" y1="-5.02" x2="196.63" y2="91.06" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
      <linearGradient id="lg6" x1="103.41" y1="7.85" x2="119.42" y2="103.93" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
      <linearGradient id="lg7" x1="28.92" y1="20.26" x2="44.94" y2="116.35" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
      <linearGradient id="lg8" x1="30.09" y1="27.23" x2="43.32" y2="106.62" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
    </defs>
    <g>
      <path fill="url(#lg1)" d="M276.84,96.6v-49.69h-4.9c-2.76,0-5-2.24-5-5v-9.22c0-2.76,2.24-5,5-5h.35c2.51,0,4.55-2.04,4.55-4.55h0c0-18.46,11.91-23.14,25.69-23.14,9.37,0,18.46,5.56,22.74,11.13l-13.91,9.95c-.83.59-1.96.45-2.64-.3-1.89-2.09-3.58-3.32-5.92-3.32-3.75,0-4.15,2.91-4.15,5.82v4.43h15.59c.33,0,.6.27.6.6v12.62c0,3.31-2.69,6-6,6h-10.19v49.69h-21.81Z"/>
      <path fill="url(#lg2)" d="M357.11,25.79c21,0,38.13,16.56,38.13,36.29s-17.12,36.29-38.13,36.29-37.99-16.31-37.99-36.29,16.99-36.29,37.99-36.29ZM357.11,78.65c9.77,0,17.53-7.46,17.53-16.82s-7.76-17.07-17.53-17.07-17.26,7.97-17.26,17.07,7.49,16.82,17.26,16.82Z"/>
      <path fill="url(#lg3)" d="M428.02,27.69l.45,4.55c.19,1.88,2.43,2.77,3.84,1.5,4.62-4.14,11.2-7.95,18.86-7.95v20.61c-10.17,0-18.86,3.54-22.21,11.25v38.94h-21.81v-48.04c0-11.53,9.34-20.87,20.87-20.87h0Z"/>
      <path fill="url(#lg4)" d="M481,27.69v.09c.37,3.65,4.54,5.45,7.53,3.31,4.16-2.98,9.38-5.3,15.35-5.3,9.77,0,18.6,2.78,23.81,11.38,5.62-5.94,16.99-11.38,26.76-11.38,15.52,0,28.76,6.83,28.76,33.13v37.68h-21.81v-33.63c0-12.77-2.68-18.21-12.04-18.21-8.16,0-14.45,5.06-16.86,10.24.13,1.26.13,2.53.13,3.92v37.68h-21.81v-33.63c0-12.77-2.68-18.21-12.04-18.21-8.16,0-14.58,5.06-16.86,10.37v41.47h-21.81v-48.04c0-11.53,9.34-20.87,20.87-20.87h0Z"/>
      <path fill="url(#lg5)" d="M176.89,69.84c2.14,7.16,9,11.65,16.08,11.65,6.7,0,11.25-1.52,15.3-5.82l14.03,10.75c-5.94,6.95-18.08,13.02-29.33,13.02-23.01,0-34.26-19.22-34.26-36.16s13.27-36.54,34.26-36.54,32.36,21.37,32.36,36.41v6.57h-37.59v-5.67c0-5.53,4.48-10,10-10h9.26c-1.26-5.31-7.46-10.62-14.03-10.62-7.59,0-13.56,5.57-15.23,10.15-1.67,4.58-2.74,9.91-.85,16.25Z"/>
      <path fill="url(#lg6)" d="M99.8,27.7l.19,1.99c.26,2.83,3.57,4.18,5.77,2.38,4.19-3.44,9.68-6.27,15.92-6.27,14.67,0,27.43,6.83,27.43,33.12v37.67h-20.61v-33.63c0-12.77-2.78-18.21-11.63-18.21-7.71,0-14.03,5.06-16.18,10.37v41.47h-20.61v-49.18c0-10.89,8.83-19.72,19.72-19.72h0Z"/>
      <path fill="url(#lg7)" d="M35.55,24.45c19.66,0,35.68,16.4,35.68,35.93s-16.02,35.93-35.68,35.93S0,80.16,0,60.38,15.9,24.45,35.55,24.45ZM35.55,76.78c9.14,0,16.4-7.39,16.4-16.65s-7.26-16.9-16.4-16.9-16.15,7.89-16.15,16.9,7.01,16.65,16.15,16.65Z"/>
      <path fill="url(#lg8)" d="M43.23,62.68l-7.03,9.74c-.28.39-.87.39-1.16,0l-7.03-9.74c-.99-1.37-.99-3.22,0-4.6l7.03-9.75c.28-.39.87-.39,1.16,0l7.03,9.75c.99,1.37.99,3.23,0,4.6Z"/>
    </g>
  </svg>
);

const LogoIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71.23 71.86" className={className}>
    <defs>
      <linearGradient id="fi1" x1="28.92" y1="-4.19" x2="44.94" y2="91.9" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
      <linearGradient id="fi2" x1="30.09" y1="2.78" x2="43.32" y2="82.17" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#186bd9"/><stop offset="1" stopColor="#3dbff2"/>
      </linearGradient>
    </defs>
    <g>
      <path fill="url(#fi1)" d="M35.55,0c19.66,0,35.68,16.4,35.68,35.93s-16.02,35.93-35.68,35.93S0,55.71,0,35.93,15.9,0,35.55,0ZM35.55,52.33c9.14,0,16.4-7.39,16.4-16.65s-7.26-16.9-16.4-16.9-16.15,7.89-16.15,16.9,7.01,16.65,16.15,16.65Z"/>
      <path fill="url(#fi2)" d="M43.23,38.23l-7.03,9.74c-.28.39-.87.39-1.16,0l-7.03-9.74c-.99-1.37-.99-3.22,0-4.6l7.03-9.75c.28-.39.87-.39,1.16,0l7.03,9.75c.99,1.37.99,3.23,0,4.6Z"/>
    </g>
  </svg>
);

/* ------------------------------------------------------------------ */
/*  ANIMATED COUNTER HOOK                                              */
/* ------------------------------------------------------------------ */

function useCountUp(target: number, duration = 2000) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const step = (now: number) => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
            setCount(Math.round(eased * target));
            if (progress < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.3 },
    );

    observer.observe(el);
    return () => observer.unobserve(el);
  }, [target, duration]);

  return { count, ref };
}

/* ------------------------------------------------------------------ */
/*  DATA                                                               */
/* ------------------------------------------------------------------ */

const STATS = [
  { value: 30, suffix: '+', label: 'Tipos de campo' },
  { value: 100, suffix: '%', label: 'Gratuito' },
  { value: 99.9, suffix: '%', label: 'Uptime' },
  { value: 0, suffix: '∞', label: 'Formulários ilimitados', isInfinity: true },
];

const FEATURES: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: Layers,
    title: '30+ tipos de campo',
    description:
      'Texto, e-mail, rating, NPS, upload, assinatura, data e muito mais — tudo pronto para usar.',
  },
  {
    icon: Paintbrush,
    title: 'Temas personalizáveis',
    description:
      'Cores, fontes, logos e backgrounds. Cada formulário com sua própria identidade visual.',
  },
  {
    icon: GitBranch,
    title: 'Lógica condicional',
    description:
      'Fluxos inteligentes com regras de exibição, saltos condicionais e ramificações.',
  },
  {
    icon: BarChart3,
    title: 'Analytics em tempo real',
    description:
      'Acompanhe cada resposta, visualize métricas e exporte dados quando precisar.',
  },
  {
    icon: Globe,
    title: 'URLs personalizadas',
    description:
      'Publique com seu handle pessoal — @usuario/formulario. Sem domínios complicados.',
  },
  {
    icon: Zap,
    title: 'Editor slide-a-slide',
    description:
      'Cada pergunta em seu próprio slide, com preview em tempo real e drag & drop.',
  },
  {
    icon: Star,
    title: 'Scoring & NPS',
    description:
      'Pontue respostas, calcule NPS automaticamente e classifique leads de forma inteligente.',
  },
  {
    icon: Webhook,
    title: 'Webhooks & integrações',
    description:
      'Conecte formulários a qualquer ferramenta via webhooks com logs em tempo real.',
  },
];

const SHOWCASE = [
  {
    icon: MousePointerClick,
    title: 'Editor visual intuitivo',
    description:
      'Arraste, solte e personalize. Cada slide é uma pergunta, cada preview é em tempo real.',
    tags: ['Drag & Drop', 'Preview ao vivo', 'Atalhos de teclado'],
  },
  {
    icon: GitBranch,
    title: 'Fluxos condicionais',
    description:
      'Crie jornadas únicas para cada respondente com lógica avançada e editor de fluxo visual.',
    tags: ['Se/Então', 'Salto condicional', 'Editor de fluxo'],
  },
  {
    icon: BarChart3,
    title: 'Analytics poderoso',
    description:
      'Dashboards com métricas em tempo real, exportação de dados e visualização de respostas.',
    tags: ['Tempo real', 'Exportar CSV', 'Filtros'],
  },
];

const SOCIAL_PROOF = [
  'Formulários ilimitados',
  'Respostas ilimitadas',
  'Sem cartão de crédito',
  'Setup em 2 minutos',
  'Suporte incluso',
  'Temas premium',
  'Lógica avançada',
  'Exportação de dados',
];

const CHECKLIST = [
  'Formulários e respostas ilimitados',
  'Editor slide-a-slide',
  '30+ tipos de campo',
  'Temas e branding próprio',
  'Lógica condicional avançada',
  'Scoring & NPS',
  'URLs personalizadas',
  'Webhooks & integrações',
  'Analytics em tempo real',
  'Exportação de dados',
  'Templates prontos',
  'Segurança de nível enterprise',
];

/* ------------------------------------------------------------------ */
/*  STAT CARD                                                          */
/* ------------------------------------------------------------------ */

const StatCard: React.FC<{ value: number; suffix: string; label: string; isInfinity?: boolean }> = ({
  value,
  suffix,
  label,
  isInfinity,
}) => {
  const { count, ref } = useCountUp(value, 1800);

  return (
    <div ref={ref} className="text-center">
      <div className="text-3xl sm:text-4xl font-bold text-white tabular-nums">
        {isInfinity ? (
          <span className="gradient-text text-4xl sm:text-5xl">∞</span>
        ) : (
          <>
            {suffix === '%' && value === 99.9
              ? (count === 100 ? '99.9' : count.toString())
              : count}
            <span className="text-primary-400">{isInfinity ? '' : suffix}</span>
          </>
        )}
      </div>
      <div className="text-sm text-neutral-400 mt-1">{label}</div>
    </div>
  );
};

/* ------------------------------------------------------------------ */
/*  COMPONENT                                                          */
/* ------------------------------------------------------------------ */

export function LandingPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-50 font-sans overflow-x-hidden">
      {/* ── Background ────────────────────────────────────────── */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="grid-bg absolute inset-0 opacity-40" />
        <div
          className="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[120px]"
          style={{ animation: 'floatBlob 15s ease-in-out infinite' }}
        />
        <div
          className="absolute bottom-[-20%] left-[-5%] w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-[100px]"
          style={{ animation: 'floatBlob 20s ease-in-out infinite reverse' }}
        />
        <div
          className="absolute top-[40%] left-[50%] w-[400px] h-[400px] bg-primary-600/5 rounded-full blur-[100px]"
          style={{ animation: 'floatBlob 18s ease-in-out infinite' }}
        />
      </div>

      {/* ── Navbar ────────────────────────────────────────────── */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-neutral-950/80 backdrop-blur-xl border-b border-neutral-800/50'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center cursor-pointer">
            <LogoFull className="h-8" />
          </Link>

          <div className="hidden sm:flex items-center gap-8 text-sm text-neutral-400">
            <a href="#features" className="hover:text-white transition-colors cursor-pointer">
              Recursos
            </a>
            <a href="#showcase" className="hover:text-white transition-colors cursor-pointer">
              Como funciona
            </a>
            <Link to="/pricing" className="hover:text-white transition-colors cursor-pointer">
              Preços
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/auth/login"
              className="inline-flex items-center justify-center text-neutral-300 hover:text-white font-medium transition-colors text-sm px-4 py-2 min-h-[44px] sm:min-h-0 cursor-pointer"
            >
              Entrar
            </Link>
            <Link
              to="/auth/register"
              className="hidden sm:inline-flex items-center justify-center text-white bg-primary-600 hover:bg-primary-500 font-medium rounded-full transition-all duration-200 px-4 py-2 text-sm gap-1.5 cursor-pointer hover:shadow-[0_0_20px_rgba(59,130,246,0.4)]"
            >
              Começar grátis
              <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        </div>
      </nav>

      {/* ── Hero ──────────────────────────────────────────────── */}
      <section className="relative z-10 max-w-5xl mx-auto px-6 pt-32 sm:pt-40 pb-20 text-center">
        <div className="hero-glow absolute inset-0 pointer-events-none" />

        <Reveal variant="blur-in">
          <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-medium bg-primary-950/60 text-primary-300 border border-primary-800/40 mb-8 cursor-default">
            <Sparkles className="w-3.5 h-3.5" />
            Formulários inteligentes para equipes modernas
          </span>
        </Reveal>

        <Reveal variant="fade-up" delay={100}>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.1]">
            Crie formulários que
            <br />
            <span className="gradient-text">convertem de verdade</span>
          </h1>
        </Reveal>

        <Reveal variant="fade-up" delay={250}>
          <p className="mt-6 text-lg sm:text-xl text-neutral-400 max-w-2xl mx-auto leading-relaxed">
            Editor visual, lógica condicional, temas personalizáveis e analytics em tempo real.
            Tudo em uma experiência que parece mágica.
          </p>
        </Reveal>

        <Reveal variant="fade-up" delay={400}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/auth/register"
              className="group inline-flex items-center justify-center text-white bg-primary-600 hover:bg-primary-500 font-medium rounded-full transition-all duration-300 px-7 py-3.5 text-base gap-2 cursor-pointer"
              style={{ animation: 'glow-pulse 3s ease-in-out infinite' }}
            >
              Criar meu primeiro formulário
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Link>
            <a
              href="#showcase"
              className="inline-flex items-center justify-center text-neutral-300 hover:text-white font-medium rounded-full transition-all duration-200 px-6 py-3.5 text-base gap-2 border border-neutral-800 hover:border-neutral-600 cursor-pointer"
            >
              <Play className="w-4 h-4" />
              Ver como funciona
            </a>
          </div>
        </Reveal>

        {/* Stats bar */}
        <Reveal variant="fade-up" delay={550}>
          <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-8 max-w-2xl mx-auto">
            {STATS.map((stat) => (
              <StatCard key={stat.label} {...stat} />
            ))}
          </div>
        </Reveal>
      </section>

      {/* ── Editor Preview ────────────────────────────────────── */}
      <section className="relative z-10 max-w-5xl mx-auto px-6 pb-32">
        <Reveal variant="zoom-in">
          <div className="relative rounded-2xl overflow-hidden p-[1px] bg-gradient-to-b from-neutral-700/50 to-neutral-800/20">
            <div className="bg-neutral-900/90 rounded-2xl overflow-hidden">
              {/* Mock browser chrome */}
              <div className="flex items-center gap-2 px-5 py-3 bg-neutral-900 border-b border-neutral-800/50">
                <div className="flex gap-1.5">
                  <div className="w-3 h-3 rounded-full bg-neutral-700" />
                  <div className="w-3 h-3 rounded-full bg-neutral-700" />
                  <div className="w-3 h-3 rounded-full bg-neutral-700" />
                </div>
                <div className="flex-1 flex justify-center">
                  <div className="px-4 py-1 rounded-md bg-neutral-800/50 text-xs text-neutral-500 flex items-center gap-1.5">
                    <Globe className="w-3 h-3" />
                    oneform.app/editor
                  </div>
                </div>
              </div>

              {/* Mock editor content */}
              <div className="p-6 sm:p-10 flex flex-col lg:flex-row gap-8 items-center">
                {/* Left: Slide list */}
                <div className="flex lg:flex-col gap-2 shrink-0">
                  {['1', '2', '3', '4'].map((n, i) => (
                    <div
                      key={n}
                      className={`w-12 h-12 rounded-lg flex items-center justify-center text-sm font-medium transition-colors ${
                        i === 0
                          ? 'bg-primary-600/20 text-primary-400 border border-primary-500/30'
                          : 'bg-neutral-800/50 text-neutral-500 border border-neutral-700/30'
                      }`}
                    >
                      {n}
                    </div>
                  ))}
                </div>

                {/* Center: Preview */}
                <div className="flex-1 text-center space-y-5">
                  <MousePointerClick className="w-12 h-12 text-primary-400 mx-auto" />
                  <p className="text-neutral-300 max-w-md mx-auto leading-relaxed">
                    Arraste, solte e personalize. O editor slide-a-slide transforma a criação de
                    formulários em uma experiência visual e intuitiva.
                  </p>
                  <div className="flex flex-wrap justify-center gap-2 mt-4">
                    {[
                      'Texto',
                      'E-mail',
                      'Rating',
                      'NPS',
                      'Upload',
                      'Assinatura',
                      'Data',
                      'Seleção',
                      'Telefone',
                      'Escala',
                    ].map((tag) => (
                      <span
                        key={tag}
                        className="px-3 py-1 rounded-full text-xs font-medium bg-neutral-800/60 text-neutral-400 border border-neutral-700/40"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Right: Properties */}
                <div className="hidden lg:flex flex-col gap-3 w-44 shrink-0">
                  {['Obrigatório', 'Placeholder', 'Validação', 'Lógica'].map((prop) => (
                    <div
                      key={prop}
                      className="px-3 py-2 rounded-lg bg-neutral-800/40 border border-neutral-700/30 text-xs text-neutral-400"
                    >
                      {prop}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </section>

      {/* ── Social proof marquee ──────────────────────────────── */}
      <section className="relative z-10 py-8 border-y border-neutral-800/40 overflow-hidden">
        <div
          className="flex gap-8 whitespace-nowrap"
          style={{ animation: 'marquee 30s linear infinite' }}
        >
          {[...SOCIAL_PROOF, ...SOCIAL_PROOF].map((item, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-2 text-sm text-neutral-500 shrink-0"
            >
              <CheckCircle2 className="w-4 h-4 text-primary-500/60" />
              {item}
            </span>
          ))}
        </div>
      </section>

      {/* ── Features grid ─────────────────────────────────────── */}
      <section id="features" className="relative z-10 max-w-6xl mx-auto px-6 py-28">
        <Reveal>
          <div className="text-center mb-16">
            <span className="text-xs font-medium text-primary-400 uppercase tracking-widest">
              Recursos
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mt-3">
              Tudo que você precisa.
              <br />
              <span className="text-neutral-400">Nada que não precisa.</span>
            </h2>
            <p className="text-neutral-400 max-w-xl mx-auto mt-4 text-lg">
              Funcionalidades pensadas para criar formulários profissionais sem complicação.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {FEATURES.map((feat, i) => (
            <Reveal key={feat.title} variant="fade-up" delay={i * 70}>
              <div className="group relative liquid-glass rounded-2xl p-6 h-full hover:border-primary-500/30 transition-all duration-300 cursor-default">
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary-600/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative">
                  <div className="w-10 h-10 rounded-xl bg-primary-900/30 border border-primary-700/20 flex items-center justify-center mb-4 group-hover:bg-primary-800/40 transition-colors">
                    <feat.icon className="w-5 h-5 text-primary-400" />
                  </div>
                  <h3 className="text-white font-semibold mb-2">{feat.title}</h3>
                  <p className="text-sm text-neutral-400 leading-relaxed">{feat.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ── Showcase / How it works ───────────────────────────── */}
      <section id="showcase" className="relative z-10 max-w-6xl mx-auto px-6 pb-28">
        <Reveal>
          <div className="text-center mb-16">
            <span className="text-xs font-medium text-primary-400 uppercase tracking-widest">
              Como funciona
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mt-3">
              Poderoso por dentro.
              <br />
              <span className="text-neutral-400">Simples por fora.</span>
            </h2>
          </div>
        </Reveal>

        <div className="space-y-6">
          {SHOWCASE.map((item, i) => (
            <Reveal key={item.title} variant={i % 2 === 0 ? 'fade-right' : 'fade-left'} delay={i * 100}>
              <div className="group liquid-glass rounded-2xl p-8 sm:p-10 hover:border-primary-500/20 transition-all duration-300">
                <div className="flex flex-col lg:flex-row items-start gap-6">
                  <div className="w-14 h-14 rounded-2xl bg-primary-900/30 border border-primary-700/20 flex items-center justify-center shrink-0 group-hover:bg-primary-800/40 transition-colors">
                    <item.icon className="w-7 h-7 text-primary-400" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs font-medium text-primary-400/60 uppercase tracking-wider">
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      <ChevronRight className="w-3 h-3 text-neutral-600" />
                      <h3 className="text-xl font-semibold text-white">{item.title}</h3>
                    </div>
                    <p className="text-neutral-400 leading-relaxed max-w-2xl">{item.description}</p>
                    <div className="flex flex-wrap gap-2 mt-4">
                      {item.tags.map((tag) => (
                        <span
                          key={tag}
                          className="px-3 py-1 rounded-full text-xs font-medium bg-neutral-800/50 text-neutral-500 border border-neutral-700/30"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ── Templates teaser ──────────────────────────────────── */}
      <section className="relative z-10 max-w-6xl mx-auto px-6 pb-28">
        <Reveal variant="fade-up">
          <div className="liquid-glass rounded-2xl p-8 sm:p-12 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1">
              <div className="w-12 h-12 rounded-xl bg-primary-900/30 border border-primary-700/20 flex items-center justify-center mb-4">
                <LayoutTemplate className="w-6 h-6 text-primary-400" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                Comece com templates prontos
              </h3>
              <p className="text-neutral-400 leading-relaxed max-w-lg">
                Galeria de templates para pesquisas, feedback, NPS, cadastros e mais. Escolha,
                personalize e publique em minutos.
              </p>
              <Link
                to="/auth/register"
                className="inline-flex items-center gap-1.5 mt-5 text-sm font-medium text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
              >
                Explorar templates
                <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-3 shrink-0">
              {['Pesquisa NPS', 'Formulário de contato', 'Quiz com scoring', 'Feedback do cliente'].map(
                (tpl) => (
                  <div
                    key={tpl}
                    className="px-4 py-3 rounded-xl bg-neutral-800/40 border border-neutral-700/30 text-sm text-neutral-400 whitespace-nowrap"
                  >
                    {tpl}
                  </div>
                ),
              )}
            </div>
          </div>
        </Reveal>
      </section>

      {/* ── Pricing ─────────────────────────────────────────── */}
      <section id="pricing" className="relative z-10 max-w-5xl mx-auto px-6 pb-28">
        <Reveal>
          <div className="text-center mb-14">
            <span className="text-xs font-medium text-primary-400 uppercase tracking-widest">
              Planos
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold mt-3">
              Simples, transparente, justo.
            </h2>
            <p className="text-neutral-400 mt-3 text-lg">
              Escolha o plano ideal e comece a criar formulários agora.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Mensal */}
          <Reveal variant="fade-up" delay={100}>
            <div className="liquid-glass rounded-2xl p-8 sm:p-10 h-full flex flex-col">
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-white mb-1">Mensal</h3>
                <p className="text-sm text-neutral-400">Flexibilidade total, cancele quando quiser.</p>
              </div>
              <div className="flex items-baseline gap-1 mb-8">
                <span className="text-4xl sm:text-5xl font-bold text-white">R$ 97</span>
                <span className="text-neutral-400 text-lg">/mês</span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 flex-1">
                {CHECKLIST.map((item) => (
                  <div key={item} className="flex items-center gap-2.5">
                    <CheckCircle2 className="w-4 h-4 text-primary-400 shrink-0" />
                    <span className="text-neutral-200 text-sm">{item}</span>
                  </div>
                ))}
              </div>
              <div className="mt-8">
                <Link
                  to="/auth/register"
                  className="w-full inline-flex items-center justify-center text-white border border-primary-500/50 hover:bg-primary-600/20 font-medium rounded-full transition-all duration-200 px-8 py-3.5 text-base gap-2 cursor-pointer"
                >
                  Começar agora
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </Reveal>

          {/* Anual — destacado */}
          <Reveal variant="fade-up" delay={200}>
            <div className="relative rounded-2xl overflow-hidden p-[1px] bg-gradient-to-b from-primary-500/50 to-primary-800/20 h-full">
              <div className="bg-neutral-900/95 rounded-2xl p-8 sm:p-10 h-full flex flex-col">
                <div className="flex items-start justify-between mb-6">
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-1">Anual</h3>
                    <p className="text-sm text-neutral-400">Melhor custo-benefício.</p>
                  </div>
                  <span className="px-3 py-1 rounded-full text-xs font-semibold bg-primary-600/20 text-primary-300 border border-primary-500/30">
                    Mais popular
                  </span>
                </div>
                <div className="mb-2">
                  <span className="block text-sm text-neutral-400 font-medium">12x de</span>
                  <span className="text-4xl sm:text-5xl font-bold text-white">R$ 87</span>
                </div>
                <p className="text-xs text-neutral-500 mb-2">
                  ou R$ 1.044 à vista
                </p>
                <p className="text-sm text-primary-400 mb-8">
                  Economize R$ 120 comparado ao plano mensal
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 flex-1">
                  {CHECKLIST.map((item) => (
                    <div key={item} className="flex items-center gap-2.5">
                      <CheckCircle2 className="w-4 h-4 text-primary-400 shrink-0" />
                      <span className="text-neutral-200 text-sm">{item}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-8">
                  <Link
                    to="/auth/register"
                    className="w-full inline-flex items-center justify-center text-white bg-primary-600 hover:bg-primary-500 font-medium rounded-full transition-all duration-200 px-8 py-3.5 text-base gap-2 cursor-pointer hover:shadow-[0_0_20px_rgba(59,130,246,0.4)]"
                  >
                    Assinar anual
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── Final CTA ─────────────────────────────────────────── */}
      <section className="relative z-10 max-w-4xl mx-auto px-6 pb-32 text-center">
        <div className="hero-glow absolute inset-0 pointer-events-none" />
        <Reveal variant="elastic-up">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            Pronto para criar formulários
            <br />
            <span className="gradient-text">que fazem a diferença?</span>
          </h2>
          <p className="text-neutral-400 mt-5 mb-10 text-lg max-w-lg mx-auto">
            Junte-se a quem já escolheu a forma mais inteligente de coletar dados.
          </p>
          <Link
            to="/auth/register"
            className="inline-flex items-center justify-center text-white bg-primary-600 hover:bg-primary-500 font-medium rounded-full transition-all duration-300 px-8 py-4 text-lg gap-2 cursor-pointer"
            style={{ animation: 'glow-pulse 3s ease-in-out infinite' }}
          >
            Começar grátis — leva 30 segundos
            <ArrowRight className="w-5 h-5" />
          </Link>
        </Reveal>
      </section>

      {/* ── Footer ────────────────────────────────────────────── */}
      <footer className="relative z-10 border-t border-neutral-800/50 py-10">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2.5">
              <LogoIcon className="h-6 w-6 opacity-60" />
              <span className="text-sm text-neutral-500">
                &copy; {new Date().getFullYear()} {SITE_NAME}. Developed by{' '}
                <a
                  href="https://vecta.id"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-400 hover:text-white transition-colors cursor-pointer"
                >
                  Vecta
                </a>
              </span>
            </div>
            <div className="flex items-center gap-8 text-sm text-neutral-500">
              <a href="#features" className="hover:text-neutral-300 transition-colors cursor-pointer">
                Recursos
              </a>
              <a href="#showcase" className="hover:text-neutral-300 transition-colors cursor-pointer">
                Como funciona
              </a>
              <Link
                to="/auth/login"
                className="hover:text-neutral-300 transition-colors cursor-pointer"
              >
                Entrar
              </Link>
              <Link
                to="/auth/register"
                className="hover:text-neutral-300 transition-colors cursor-pointer"
              >
                Criar conta
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
